/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  } 
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 0;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

const atcButtons = document.querySelectorAll('.js-add-to-cart');
document.body.addEventListener('click', event => {
	if (event.target.classList.contains('js-add-to-cart')) {
    event.preventDefault();

    const id = Number(event.target.dataset.id);

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        atcGetSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').rerender(true);
        
      });
  }
});

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  onShow: modal => console.info(`${modal.id} is shown`), // [1]
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

// GSAP
gsap.registerPlugin(ScrollTrigger);

/*================ Animations ================*/
// Fade In
gsap.utils
  .toArray('.fade-in-up')
  .forEach(elem => {
    const duration = Number(elem.dataset.duration);
    const delay = Number(elem.dataset.delay);

    gsap.to(elem, { 
      opacity: 1,
      y: 0,
      duration: duration || .3,
      delay: delay || 0,
      ease: 'linear',
      scrollTrigger: {
        trigger: elem,
        start: "top 93%"
      }
    });
  });

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.body = document.body;
    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.buttonContainer = document.querySelector('.header__menu-button-container');

    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.menuButtons = document.querySelectorAll('button.menu-drawer__menu-button'); 
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
  }

  openMenuDrawer() {
    const fromTop = document.querySelector('.header').offsetHeight + document.querySelector('.header').getBoundingClientRect().top;
    this.drawer.style.top = `${fromTop - 1}px`;

    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', false);

    this.body.classList.add('scroll-lock');

    this.buttonContainer.classList.add('menu-is-open');
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.body.classList.remove('scroll-lock');

    this.buttonContainer.classList.remove('menu-is-open');
  }

  toggleMenuButtons(event) {
    const parent = event.target.parentElement;
    const secondaryMenu = event.target.nextElementSibling;

    if(secondaryMenu.classList.contains("menu-drawer__secondary-menu")) {
      secondaryMenu.getAttribute("aria-hidden") == 'true' ? secondaryMenu.setAttribute('aria-hidden', 'false' ) : secondaryMenu.setAttribute('aria-hidden', 'true' )
    } else {
      parent.getAttribute("aria-hidden") == 'true' ? parent.setAttribute('aria-hidden', 'false' ) : parent.setAttribute('aria-hidden', 'true' )
    }
    
    // if (parent.classList.contains('is-open')) {
    //   slideUp(secondaryMenu);
    //   parent.classList.remove('is-open');
    // } else {
    //   slideDown(secondaryMenu);
    //   parent.classList.add('is-open');
    // }
  }
}

customElements.define('menu-drawer', MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.products = JSON.parse(document.querySelector('.product').querySelector('.collection-data').textContent)
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateInfoText(event);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      if (this.products) this.updateColorAvailability();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateInfoText(event) {
    let value = event.target.closest('input:checked').value;
    const activeTexts = this.querySelectorAll('.product-form__selected-input');

    activeTexts.forEach(activeText => {
      activeText.innerHTML = value;
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.innerHTML = text;
    } else {
      if (addButton.dataset.preorder == 'true') {
        addButton.removeAttribute('disabled');
        addButtonText.innerHTML = 'Preorder';
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.innerHTML = 'Add <span class="hide-product-bar">To Cart</span>';
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateColorAvailability() {
    const size = event.target.value;
    const swatches = this.closest('.product').querySelectorAll('.product__swatches-swatch');

    swatches.forEach(swatch => {
      let currentColor = swatch.dataset.color
      let isAvailable = false
      let url = ''

      this.products.forEach(product => {
        if (product.title.includes(currentColor)) {
          product.variants.forEach(variant => {
            if (variant.title.includes(size)) {
              if (variant.available) isAvailable = true
              url = `${window.location.protocol}//${window.location.host}/products/${[product.handle]}?variant=${variant.id}`
            }
          })
        }
      })

      isAvailable ? swatch.classList.remove('sold-out') : swatch.classList.add('sold-out')
      swatch.querySelector('a').setAttribute('href', url)
    })
  }
}

customElements.define('variant-selects', VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class collectionFilters extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector('.product-grid');
    this.form = document.querySelector('.filters-form');
    this.dropdownButtons = document.querySelectorAll('.filter-bar__dropdown-button');
    this.filterButtons = document.querySelectorAll('.filter-bar__filter-button');
    this.activeTagsContainer = this.querySelectorAll('.filter-bar__active-filters');
    this.clearCategoryButtons = this.querySelectorAll('.filter-bar__clear-dropdown');
    this.clearAllFiltersButtons = this.querySelectorAll('.js-clear-all-filters');
    this.openMobileFilterButtons = document.querySelectorAll('.js-open-mobile-filters');
    this.closeMobileFilterButtons = document.querySelectorAll('.js-close-mobile-filters');

    this.setListeners();
  }

  setListeners() {
    // Handle Dropdown Click
    this.dropdownButtons.forEach(item => {
      item.addEventListener('click', this.handleDropdownClick);
    });

    // Handle Filter Click
    [...this.querySelectorAll('.filter-bar__filter-button')].forEach(item => {
      if (item.classList.contains('sort-by')) {
        item.addEventListener('click', this.handleSortClick.bind(this));
      } else {
        item.addEventListener('click', this.handleFilterClick.bind(this));
      }
    });

    // Handle Remove Filter
    this.activeTagsContainer.forEach(a => {
      a.addEventListener('click', event => {
        event.preventDefault();
        
        const button = event.target.closest('.remove-filter');
  
        if (button) {
          const filter = button.dataset.filter;
          const initial = button.dataset.url;
          const newUrl = window.location.protocol + '//' + window.location.host + initial;
    
          this.removeSelectedFilter(filter);
          this.reloadSections(newUrl);
          this.closeAllDropdowns();
        }
      });
    })

    // Clear Category Filters
    this.clearCategoryButtons.forEach(button => {
      button.addEventListener('click', this.clearCategoryFilters.bind(this));
    });

    // Clear All Filters
    this.clearAllFiltersButtons.forEach(button => {
      button.addEventListener('click', this.clearAllFilters.bind(this));
    });

    // Mobile open
    this.openMobileFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        event.preventDefault();
        const overlay = document.querySelector('.filters__mobile-overlay');

        document.querySelector('.filter-bar__left').classList.add('active');
        overlay.classList.add('active');
        overlay.addEventListener('click', event => {
          document.querySelector('.filter-bar__left').classList.remove('active');
          overlay.classList.remove('active');
        });
      });
    });

    // Mobile close
    this.closeMobileFilterButtons.forEach(filter => {
      filter.addEventListener('click', event => {
        event.preventDefault();

        document.querySelector('.filter-bar__left').classList.remove('active');
        document.querySelector('.filters__mobile-overlay').classList.remove('active');
      });
    });
  }

  handleDropdownClick(event) {
    event.preventDefault();

    slideToggle(this.nextElementSibling)
    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      // Close other dropdowns first
      document.querySelectorAll('.filter-bar__dropdown-button').forEach(item => {
        item.classList.remove('active');
      });

      this.classList.add('active');
    }
  }

  handleFilterClick(event) {
    const activeFiltersLength = event.target.closest(".filter-bar__dropdown-container").querySelectorAll("input[type='checkbox']:checked").length

    if(!event.target.closest(".filter-bar__dropdown").classList.contains(".filter-bar__sorting-dropdown")) {
      event.target.closest(".filter-bar__dropdown").querySelector(".filter-bar__dropdown-count").textContent = `(${activeFiltersLength})`

      console.log(activeFiltersLength > 0)

      event.target.closest(".filter-bar__dropdown").querySelector(".filter-bar__dropdown-button").classList.toggle("has-active-filters", activeFiltersLength > 0)
    }

    this.reloadSections();
  }

  removeSelectedFilter(filter) {
    document.querySelector(`.filter-bar__filter-button[name="${filter}"]:checked`).checked = false;
  }

  handleSortClick(event) {
    const sort = event.currentTarget.value;
    this.sortBy = sort;

    event.target.closest(".filter-bar__dropdown").querySelector(".filter-bar__sort-by-value").innerText = event.target.dataset.name
    
    // this.closeAllDropdowns();
    this.reloadSections();
  }

  closeAllDropdowns() {
    this.dropdownButtons.forEach(button => {
      if (button.classList.contains('active')) {
        button.classList.remove('active');
      }
    });
  }

  clearCategoryFilters(event) {
    event.preventDefault();
    event.currentTarget.parentElement.querySelectorAll('input:checked').forEach( i => {i.checked = false})

    // this.closeAllDropdowns();
    this.reloadSections();
  }

  clearAllFilters(event) {
    event.preventDefault();

    this.querySelectorAll('.filter-bar__filters input:checked').forEach(item => {
      item.removeAttribute('checked');
      item.checked = false
    });

    this.closeAllDropdowns();
    this.reloadSections();

    document.querySelector('.filter-bar__left').classList.remove('active');
    document.querySelector('.filters__mobile-overlay').classList.remove('active');
  }

  reloadSections() {
    const formData = new FormData(this.form);
    let searchParams = new URLSearchParams(formData).toString();

    let querySearchParam = new URLSearchParams(window.location.search).get('q') || ''

    if(location.pathname == '/search' && querySearchParam != '' ) {
      searchParams = searchParams + `&q=${querySearchParam}`
    }
    
    const url = location.pathname + '?' + searchParams;

    if (history.replaceState) {
      window.history.pushState({ path: url }, '', url);
    }
    // Fetch and replace sections
    this.enableLoading();
    fetch(location.pathname + '?' + searchParams)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id).innerHTML;
        }));
      
        this.disableLoading();
      })
      .finally(() => {
        this.querySelectorAll(".filter-bar__dropdown").forEach( c => {
          let count = c.closest(".filter-bar__dropdown").querySelectorAll("input:checked").length
          if(c.querySelector(".filter-bar__dropdown-count")) c.querySelector(".filter-bar__dropdown-count").innerText = `(${count})`
  
          c.querySelector(".filter-bar__dropdown-button").classList.toggle("has-active-filters", count > 0)
        })
  
        this.clearAllFiltersButtons = this.querySelectorAll('.js-clear-all-filters');
        this.clearAllFiltersButtons.forEach(button => {
          button.addEventListener('click', this.clearAllFilters.bind(this));
        });
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      { id: 'product-grid' },
      { id: 'active-filters' },
      { id: 'active-filters-external' },
      { id: 'product-results' },
      { id: 'mobile-filter-count' },
      { id: 'mobile-filter-dropdown-count' }
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading() {
    this.grid.classList.add('loading');
  }

  disableLoading() {
    this.grid.classList.remove('loading');
  }
}

customElements.define('collection-filters', collectionFilters);

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.quickView = this;
    this.quickViewContent = this.querySelector('.quick-view__content');

    document.body.addEventListener('click', event => {
      if (event.target.closest('.product-card__quick-view')) {
        this.open(event.target.closest('.product-card__quick-view'));
      }
    });

    this.closeButtons = this.querySelectorAll('.quick-view__close');
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  close() {
    this.quickView.setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-lock');
    setTimeout(() => {
      this.quickViewContent.innerHTML = '';
    }, 350);
  }

  open(event) {
    const opener = event.currentTarget || event;
    opener.classList.add('loading');
    opener.querySelector('.loading-overlay').classList.remove('hidden');

    this.swapOutView(opener.dataset.productUrl, opener);
  }

  swapOutView(url, opener) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('#product');
        this.quickViewContent.innerHTML = this.productElement.innerHTML;
      
        let quickViewProductSlider = new Swiper('.quick-view .product__media-list', {
          loop: true,
          // pagination: {
          //   el: '.product__media-pagination',
          //   clickable: true
          // },
          draggable: true,
          navigation: {
            prevEl: '.product__media-button-prev',
            nextEl: '.product__media-button-next'
          },
        }); 

        window.quickViewProductSlider = quickViewProductSlider;

        setTimeout(() => {
          this.quickView.setAttribute('aria-hidden', false);
        }, 150);


        this.preventVariantURLSwitching();
      })
      .finally(() => {
        this.querySelector('.product-form__submit').addEventListener('click', event => {
          if (!event.target.disabled) {
            this.close();
          }
        });

        this.swatchButtons = this.querySelectorAll('.product__swatches-swatch a');
        this.swatchButtons.forEach(button => {
          button.addEventListener('click', this.handleSwatchButton.bind(this));
        });

        if (opener) {
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay').classList.add('hidden');
          document.body.classList.add('scroll-lock');
        }
      });
  }

  handleSwatchButton(event) {
    event.preventDefault();
    const url = event.currentTarget.href;

    this.swapOutView(url);
  }

  preventVariantURLSwitching() {
    this.quickViewContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
  }
}

customElements.define('quick-view', QuickView);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll('.product-card__swatch');
    this.cardImage = this.querySelector('.product-card__image .initial-image img');
    this.cardHoverImage = this.querySelector('.product-card__image .hover-image img');
    this.priceText = this.querySelector('.product-card__price')
    this.colorText = this.querySelector('.product-card__swatch-color-text');
    this.links = this.querySelectorAll('.product-card__link');
    this.tag = this.querySelector('.product-card__tag');


    this.handleSwatchClick = (swatch, event) => {
      event.preventDefault();
      this.onSwatchClick(swatch);
    };

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleSwatchClick.bind(this, swatch));
    });
  }

  onSwatchClick(swatch, event) {
    if (!swatch.classList.contains('active')) {
      this.updateActiveSwatch(swatch);
      this.updateImages(swatch);
      this.updateColor(swatch);
      this.updatePrice(swatch);
      this.updateLinks(swatch);
      this.updateTag(swatch);
    }
  }

  updateActiveSwatch(swatch) {
    this.swatches.forEach(swatch => {
      swatch.classList.remove('active');
    });

    swatch.classList.add('active');
  }

  updateImages(swatch) {
    const image = swatch.dataset.image;
    const hoverImage = swatch.dataset.hover;

    this.cardImage.setAttribute('src', image);
    if (this.cardHoverImage) {
      this.cardHoverImage.setAttribute('src', hoverImage);
    }
  }

  updateColor(swatch) {
    const color = swatch.dataset.color;

    this.colorText.innerHTML = color;
  }

  updatePrice(swatch) {
    const price = swatch.dataset.price;

    this.priceText.innerHTML = price;
  }

  updateLinks(swatch) {
    const url = swatch.dataset.url;

    this.links.forEach(link => {
      link.setAttribute('href', url);
    });
  }

  updateTag(swatch) {
    const available = swatch.dataset.available;
    const sale = swatch.dataset.sale;
    const tag = swatch.dataset.tag;

    if (available == 'false') {
      this.tag.classList.add('product__tag');
      this.tag.innerHTML = 'Sold Out';
      return;
    } else if (sale == 'true') {
      this.tag.classList.add('product__tag');
      this.tag.innerHTML = 'Sale';
      return;
    }

    if (tag && this.tag) {
      this.tag.classList.add('product__tag');
      this.tag.innerHTML = tag;
    } else if (!tag && this.tag) {
      this.tag.classList.remove('product__tag');
      this.tag.innerHTML = '';
    }
  }
}

customElements.define('product-card', ProductCard);

var AddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const id = this.dataset.id;

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    addToCart(body);
  }
}

customElements.define('add-to-cart', AddToCart);

var DropdownItem = class extends HTMLElement {
  constructor() {
    super();

    this.parent = this.querySelector('.dropdown');
    this.header = this.querySelector('.dropdown-header');
    this.content = this.querySelector('.dropdown-content');

    this.header.addEventListener('click', this.onDropdownClick.bind(this));
  }

  onDropdownClick() {
    if (this.parent.classList.contains('active')) {
      this.parent.classList.remove('active');
      slideUp(this.content, 200);
    } else {
      this.parent.classList.add('active');
      slideDown(this.content, 200);
    }
  }
}

customElements.define('dropdown-item', DropdownItem);

var ProductUpsell = class extends HTMLElement {
  constructor() {
    super();

    this.image = this.querySelector('.product-upsell__image img');
    this.priceText = this.querySelector('.product-upsell__price');
    this.colorText = this.querySelector('.product-upsell__swatch-color-text');
    this.updateCart = this.dataset.updateCart;
    this.cartDrawer = document.querySelector('cart-drawer');

    // Swatches
    this.swatches = this.querySelectorAll('.product-upsell__swatch');
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.onSwatchClick.bind(this));
    });

    // Selects
    this.selects = this.querySelectorAll('select');
    this.selects.forEach(select => {
      select.addEventListener('change', this.onSelectChange.bind(this));
    });
  }

  onSwatchClick(event) {
    event.preventDefault();
    
    this.updateActiveSwatch(event.target);
    this.updateImages(event.target);
    this.updatePriceText(event.target);
    this.updateColorText(event.target);
    this.updateVariantSelect(event.target);

    const addButton = this.querySelector(".js-add-to-cart")
    const id = this.querySelector(".product-upsell__variant-wrapper.active select").value;
    
    addButton.dataset.id = id;
    addButton.removeAttribute('disabled');
  }

  updateActiveSwatch(swatch) {
    this.swatches.forEach(swatch => {
      swatch.classList.remove('active');
    });

    swatch.classList.add('active');
  }

  updateImages(swatch) {
    const image = swatch.dataset.image;
    const color = swatch.dataset.color;

    if (image) {
      this.image.setAttribute('src', image);
      this.image.setAttribute('alt', color);
    }
  }

  updateColorText(swatch) {
    const color = swatch.dataset.color;

    this.colorText.innerHTML = color;
  }

  updatePriceText(swatch) {
    const price = swatch.dataset.price;

    this.priceText.innerHTML = price;
  }

  updateVariantSelect(swatch) {
    const product = swatch.dataset.product;
    const activeSelect = this.querySelector('.product-upsell__variant-wrapper.active');
    const newSelect = this.querySelector(`.product-upsell__variant-wrapper[data-id="${product}"]`);

    activeSelect.classList.remove('active');
    newSelect.classList.add('active');
  }

  onSelectChange(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // const selectContainer = event.target.closest('.product-upsell__variant-select');
    const selectContainer = this.querySelector('.product-upsell__variant-wrapper.active');
    // const addButton = selectContainer.nextElementSibling;
    const addButton = this.querySelector(".js-add-to-cart")
    const id = Number(event.target.value);
    
    addButton.dataset.id = id;
    addButton.removeAttribute('disabled');
  }
}

customElements.define('product-upsell', ProductUpsell);

const header = new Headroom(document.querySelector('#shopify-section-header'), {
  tolerance: 10,
  classes: {
    initial: 'header-state',
    top: 'header-state__top',
    notTop: 'header-state__not-top'
  }
});
header.init();

var LoadMore = class extends HTMLElement {
  constructor() {
    super();

    this.dataUrl = this.dataset.loadMore
    this.target = this.closest(this.dataset.container).querySelector(this.dataset.target)
    this.loadMoreWrapper = this.parentElement


    this.callback = function(entries, observer) {
      entries.forEach((entry) => {
        if(entry.isIntersecting) {
          this.handleLoadMore()
          observer.disconnect();
        } 
      });
    }
      
    this.createObserver(this.loadMoreWrapper, this.callback.bind(this));
  }

  createObserver(target, callback) {
    const options = {
        root: null,
        threshold: 0
    };
    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);
  }

  handleLoadMore() {
    this.style.opacity = 1
    this.dataUrl = this.dataset.loadMore

    fetch(this.dataUrl).then(response => response.text()).then((responseText) => {
      const html = responseText;
      const htmlContent = new DOMParser().parseFromString(html, 'text/html')

      this.target.innerHTML = this.target.innerHTML + htmlContent.querySelector(this.dataset.target).innerHTML;
      this.loadMoreWrapper.innerHTML = htmlContent.querySelector(".load-more-wrapper").innerHTML || ""

    }).finally(() => {
      this.style.opacity = 0
    })
  }
}

customElements.define('load-more', LoadMore)